import { createSlice } from '@reduxjs/toolkit';
import { addPhqQues, delPhqQues, getAutomateInterpretationList, getPhqQues } from 'services/actions/master-data/interpretationAction';

interface InterpretationState {
    loading: boolean;
    autoInterpetData: any;
    error: any;
    success: any;
    //phq get
    loading1: boolean;
    phqQues: any;
    error1: any;
    success1: boolean;
    //phq add
    loading2: boolean;
    addPhqQues: any;
    error2: any;
    success2: boolean;
    //delete phq
    loading3:boolean;
    delPhqInfo:any;
    error3:any;
    success3:boolean;
}

const initialState: InterpretationState = {
    loading: false,
    autoInterpetData: null,
    error: null,
    success: false,
    loading1: false,
    phqQues: null,
    error1: null,
    success1: false,
    loading2: false,
    error2: null,
    success2: false,
    addPhqQues: null,
    loading3:false,
    delPhqInfo:null,
    error3:null,
    success3:false,
};

const interpretationSlice = createSlice({
    name: 'interpretation-slice',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getAutomateInterpretationList.pending, (state) => {
                state.loading = true;
                state.error = null;
                state.success = false;
            })
            .addCase(getAutomateInterpretationList.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.autoInterpetData = payload;
                state.success = true;
            })
            .addCase(getAutomateInterpretationList.rejected, (state, { payload }) => {
                state.loading = false;
                state.error = payload;
                state.success = false;
            })
            .addCase(getPhqQues.pending, (state) => {
                state.loading1 = true;
                state.error1 = null;
                state.success1 = false;
                state.phqQues = null;
            })
            .addCase(getPhqQues.fulfilled, (state, { payload }) => {
                state.loading1 = false;
                state.phqQues = payload;
                state.success1 = true;
            })
            .addCase(getPhqQues.rejected, (state, { payload }) => {
                state.loading1 = false;
                state.error1 = payload;
                state.success1 = false;
            })
            .addCase(addPhqQues.pending, (state) => {
                state.loading2 = true;
                state.error2 = null;
                state.success2 = false;
                state.autoInterpetData = null;
            })
            .addCase(addPhqQues.fulfilled, (state, { payload }) => {
                state.loading2 = false;
                state.autoInterpetData = payload;
                state.success2 = true;
            })
            .addCase(addPhqQues.rejected, (state, { payload }) => {
                state.loading2 = false;
                state.error2 = payload;
                state.success2 = false;
            })
            .addCase(delPhqQues.pending, (state) => {
                state.loading3 = true;
                state.error3 = null;
                state.success3 = false;
                state.delPhqInfo = null;
            })
            .addCase(delPhqQues.fulfilled, (state, { payload }) => {
                state.loading3 = false;
                state.delPhqInfo = payload;
                state.success3 = true;
            })
            .addCase(delPhqQues.rejected, (state, { payload }) => {
                state.loading3 = false;
                state.error3 = payload;
                state.success3 = false;
            });
    },
});

export default interpretationSlice.reducer;
